import React from 'react';
import PropTypes from 'prop-types';
import './index.css';

// eslint-disable-next-line react/prefer-stateless-function
class Loading extends React.Component {
  render() {
    const { show } = this.props;

    if(!show) {
      return null;
    }

    return (
      <div className="overlay">
        <div className="overlay__loading-icon" />
      </div>
    )
  }
}

Loading.propTypes = {
  show: PropTypes.bool,
};

Loading.defaultProps = {
  show: false,
};

export default Loading;
